var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM16.0003 29.5387C8.52318 29.5387 2.46181 23.4774 2.46181 16.0003C2.46181 8.52318 8.52318 2.46181 16.0003 2.46181C23.4774 2.46181 29.5387 8.52318 29.5387 16.0003C29.5387 23.4774 23.4774 29.5387 16.0003 29.5387ZM16.0016 7.87847C16.6813 7.87847 17.2324 8.42951 17.2324 9.10924V17.1316L21.2295 21.1287C21.7101 21.6094 21.7101 22.3886 21.2295 22.8693C20.7489 23.3499 19.9696 23.3499 19.4889 22.8693L15.1313 18.5117C14.9005 18.2809 14.7708 17.9678 14.7708 17.6414V9.10924C14.7708 8.42951 15.3219 7.87847 16.0016 7.87847Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.89916ca9ac3453901df00bdca6379a41.svg";
export { ForwardRef as ReactComponent };